// extracted by mini-css-extract-plugin
module.exports =  {"secondaryText":"rLKO_r9QG7S0BfW6BtQ7","stackedCellContent":"ySb8KUyavN6myVsFJ_Jg"};